<script lang="ts">
  import { css, cx } from '@agapi/ui/panda/css';
  import { cardStyles } from '../card.styles';
  import type { CardFooterProps } from '../card.types';

  const { css: cssProp, children, ...props }: CardFooterProps = $props();

  const classes = cardStyles()
</script>

<div class={cx(classes.footer, css(cssProp))} {...props}>
  {@render children?.()}
</div>
